import react from 'react';
 

export default function Privacy() {
return (
    <section className='py-10 px-10 text-sm'>
    <h1 className='font-semibold text'>Privacy Policy</h1>
    <p>At <strong>Tech4All</strong>, your privacy matters to us. We only collect the information we truly need to provide you with the best experience.</p>

    <h2 className='font-semibold'>What we collect</h2>
    <ul className='text-xs'>
        <li>Name</li>
        <li>Email address</li>
    </ul>

    <h2 className='font-semibold'>Why we collect this</h2>
    <ul className='text-xs'>
        <li>To create and manage your account</li>
        <li>To communicate with you about your services and updates</li>
    </ul>

    <h2 className='font-semibold'>How we protect your data</h2>
    <p className='text-xs'>Your information is stored securely and is never shared, sold, or rented to anyone.</p>

    <h2 className='font-semibold'>Your rights</h2>
    <p className='text-xs'>You can request to view, update, or delete your information anytime by contacting us at <a href="mailto:contact@tech4all.in" className='text-blue-500'>contact@tech4all.in</a>.</p>

    <h2 className='font-semibold'>Updates to this policy</h2>
    <p className='text-xs'>If we make any changes to this policy, we’ll let you know by email or on our website.</p>
    </section>
)}
